import http from '@/lib/axios';

/**
 * @typedef {Object} InitOptions
 * @property {string} ueAppId 盛趣加解密服务 appId
 * @property {string} hash 用 md5 加密后的 email
 * @property {string} type email类型 详见 EmailType
 * @property {(string | undefined)} flowId 新增字段，用于在个别业务流程中插入邮件验证码验证流程。例如：账号注销
 */

/**
 * 邮箱加密流程初始化
 * @param {InitOptions} options
 * @return {Promise<{ flowId: string; key: string; operationModel: number }>}flowId：业务流程id；key：按顺序与 hash 对应；operationModel：0熔断/1正常
 */
export async function emailInit(options) {
    return http.post('basic/email/init', options);
}

/**
 * 发送验证码
 * @param {{ flowId: string; email: string; scene?: string}} params email 的密文格式为 cipherInfo
 * @return {Promise<{ nextAction: string; captchaParams: string }>}
 */
export function sendCode(params) {
    return http.post('basic/email/sendCode', params);
}

/**
 * 校验图验邮箱验证码发送
 * @param {{ flowId: string; outInfo: string; }} params
 * @return {Promise<{ nextAction: string; captchaParams: string }>}
 */
export function picCheckSendCode(params) {
    return http.post('basic/email/picCheckSendCode', params);
}

/**
 * 邮箱验证码登录
 * @return {Promise<{ userId: string; loginType: number; token: string; nextAction: string; captchaParams: string}>}
 */
export function captchaLogin(params) {
    return http.post('web/account/emailLogin', params);
}

/**
 * 邮箱静密登录
 * @return {Promise<{ userId: string; loginType: number; token: string; nextAction: string; captchaParams: string}>}
 */
export function staticLogin(params) {
    return http.post('web/account/login', params);
}

/**
 * @description 天御图验邮箱静密登录（在图验成功后，再使用该接口继续登录）
 * @return {Promise<{ userId: string; loginType: number; token: string; nextAction: string; captchaParams: string}>}
 */
export function picCheckLogin(params) {
    return http.post('web/account/picCheckLogin', params);
}

/**
 * 邮箱注册
 * @return {Promise<{ userId: string; loginType: number; token: string}>}
 */
export function register(params) {
    return http.post('web/account/register', params);
}

/**
 * 邮箱密码重置
 * @return {Promise<{ userId: string; loginType: number; token: string}>}
 */
export function resetPassword(params) {
    return http.post('web/account/resetPassword', params);
}

/**
 * 获取隐私协议
 * @return {Promise<{ privacyAgreementUrl: string; userServiceAgreementUrl: string}>}
 */
export function getProtocol() {
    // prettier-ignore
    return http.post('/agreement/user', undefined, {
        baseURL: /gray/.test(window.location.host)
            ? '//abroad-sin-gray.shengqugames-corp.com'
            : 'https://abroad-sin-protocol.shengqugames-corp.com',
    });
}

/**
 * 获取 webTick
 * @return {Promise<{ ticket: string;}>}
 */
export function getWebTicket(returnUrl, axiosConfig) {
    return http.post(
        '/web/account/getWebTicket',
        { returnUrl },
        {
            disabledToast: true,
            ...axiosConfig,
        }
    );
}

/**
 * 登出
 */
export function logout() {
    return http.post('/web/account/logout', undefined, { disabledToast: true });
}
